import { createFileRoute } from '@tanstack/react-router';
import { AdminOrdersPage } from '../../../../features/admin/market';

export const Route = createFileRoute('/_auth/admin/market/orders')({
  component: AdminOrdersPage,
});
